var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useState, useRef, useEffect } from 'react';
import Styles from './my-modules-styles.scss';
import HeaderModules from './components/header-modules/header-modules';
import { CircleLoader, ProgressBar } from '@/presentation/components';
import ModuleItem from './components/module-item/module-item';
import { useNavigate } from 'react-router';
import { useMyModules } from '@/presentation/hooks';
import ModuleCertificateApproved from './components/module-certificate-approved/module-certificate-approved';
import ModalCertificate from './components/cetificactes/modalCertificate';
import HihgCertificate from './components/cetificactes/Hihgs/HihgCertificate';
import MiddleCertificate from './components/cetificactes/Middle/MiddleCertificate';
import ElemantaryCertificate from './components/cetificactes/Elementary/ElementaryCertificate';
import html2pdf from 'html2pdf.js';
import ModuleCertificateDesApproved from './components/module-certificate-des-approved/module-certificate-des-approved';
import ElemantaryCertificateDownload from './components/cetificactes/Elementary/ElementaryCertificateDownload';
import MiddleCertificateDownload from './components/cetificactes/Middle/MiddleCertificateDownload';
import HihgCertificateDownload from './components/cetificactes/Hihgs/HihgCertificateDownload';
import useUserSesssion from '@/presentation/hooks/use-user-session';
import ModuleCurrentItem from './components/module-current-item/module-current-item';
import { MountainIcon } from '@/presentation/components/icons';
import { toCardinal } from '@/presentation/functions/cardinal';
import { formatNameToFile } from '@/presentation/utils/student-utils';
const getRandomColor = (indexParam) => {
    const colors = ['blue', 'green', 'purple', 'orange', 'red'];
    const colorIndex = indexParam % colors.length;
    return colors[colorIndex];
};
const MyModules = ({ loadKeywords, loadModules, manageStripe }) => {
    const navigate = useNavigate();
    const { loading, modules, cumulativeScore, currentProgress, studentGrade } = useMyModules({
        loadKeywords,
        loadModules
    });
    const { user } = useUserSesssion();
    const containerRef = useRef(null);
    const [downloadCertficate, setDownloadCertficate] = useState(false);
    const [openModalCertificate, setOpenModalCertificate] = useState(false);
    const studentGradeText = toCardinal(studentGrade);
    useEffect(() => {
        if (currentProgress === 100) {
            manageStripe
                .studentCompleteGrade()
                .then(data => console.log(data))
                .catch(error => console.error(error === null || error === void 0 ? void 0 : error.message));
        }
    }, [currentProgress]);
    useEffect(() => {
        if (user === null || user === void 0 ? void 0 : user.id) {
            if ((user === null || user === void 0 ? void 0 : user.gender) === null || (user === null || user === void 0 ? void 0 : user.ethnicity) === null || (user === null || user === void 0 ? void 0 : user.dateOfBirthday) === null) {
                navigate('/student-dashboard/first-login');
            }
        }
    }, [user === null || user === void 0 ? void 0 : user.id]);
    const certificateRender = (grade, height, width) => {
        if (grade >= 3 && grade <= 5) {
            return (React.createElement(ElemantaryCertificate, { grade: studentGradeText, name: (user === null || user === void 0 ? void 0 : user.fullName) || '', height: height || '60vh', width: width || '83vh' }));
        }
        else if (grade >= 6 && grade <= 8) {
            return (React.createElement(MiddleCertificate, { grade: studentGradeText, name: (user === null || user === void 0 ? void 0 : user.fullName) || '', height: height || '60vh', width: width || '83vh' }));
        }
        else {
            return (React.createElement(HihgCertificate, { grade: studentGradeText, name: (user === null || user === void 0 ? void 0 : user.fullName) || '', height: height || '60vh', width: width || '83vh' }));
        }
    };
    const certificateRenderDownload = (grade, height, width) => {
        if (grade >= 3 && grade <= 5) {
            return (React.createElement(ElemantaryCertificateDownload, { grade: studentGradeText, name: (user === null || user === void 0 ? void 0 : user.fullName) || '', height: height || '60vh', width: width || '83vh' }));
        }
        else if (grade >= 6 && grade <= 8) {
            return (React.createElement(MiddleCertificateDownload, { grade: studentGradeText, name: (user === null || user === void 0 ? void 0 : user.fullName) || '', height: height || '60vh', width: width || '83vh' }));
        }
        else {
            return (React.createElement(HihgCertificateDownload, { grade: studentGradeText, name: (user === null || user === void 0 ? void 0 : user.fullName) || '', height: height || '60vh', width: width || '83vh' }));
        }
    };
    const handleDownload = () => __awaiter(void 0, void 0, void 0, function* () {
        setDownloadCertficate(true);
        const element = containerRef.current;
        const options = {
            margin: 0,
            filename: `certificate_${studentGradeText}_${formatNameToFile(user === null || user === void 0 ? void 0 : user.fullName)}.pdf`,
            image: { type: 'png', quality: 2 },
            html2canvas: { scale: 2 },
            jsPDF: { unit: 'in', format: 'a5', orientation: 'landscape' }
        };
        // const printElement = pdfJSX();
        yield html2pdf().set(options).from(element).save();
        setDownloadCertficate(false);
    });
    const handleOnContinue = () => {
        const findCurrentModule = modules.find(module => module === null || module === void 0 ? void 0 : module.currentModule);
        if (findCurrentModule)
            navigate(`/student-dashboard/my-modules/${findCurrentModule === null || findCurrentModule === void 0 ? void 0 : findCurrentModule.id}`);
    };
    const setItemByStatus = (module, index) => {
        if (module === null || module === void 0 ? void 0 : module.currentModule) {
            return (React.createElement(ModuleCurrentItem, { key: module === null || module === void 0 ? void 0 : module.id, backgroundColor: getRandomColor(index), icon: React.createElement(MountainIcon, null), type: "in-progress", onClick: () => navigate(`/student-dashboard/my-modules/${module === null || module === void 0 ? void 0 : module.id}`), module: {
                    moduleTitle: `Module ${index + 1}`,
                    title: module === null || module === void 0 ? void 0 : module.name,
                    description: module === null || module === void 0 ? void 0 : module.summary,
                    completed: false,
                    progress: (module === null || module === void 0 ? void 0 : module.studentProgressInModulePercent) || 0,
                    score: (module === null || module === void 0 ? void 0 : module.studentScoreInModulePercent) || 0
                } }));
        }
        return (React.createElement(ModuleItem, { key: module === null || module === void 0 ? void 0 : module.id, backgroundColor: getRandomColor(index), type: (module === null || module === void 0 ? void 0 : module.studentProgressInModulePercent) === 100 ? 'completed' : 'blocked', onClick: () => navigate(`/student-dashboard/my-modules/${module === null || module === void 0 ? void 0 : module.id}`), module: {
                moduleTitle: `Module ${index + 1}`,
                title: module === null || module === void 0 ? void 0 : module.name,
                completed: (module === null || module === void 0 ? void 0 : module.studentProgressInModulePercent) === 100,
                progress: (module === null || module === void 0 ? void 0 : module.studentProgressInModulePercent) || 0,
                score: (module === null || module === void 0 ? void 0 : module.studentScoreInModulePercent) || 0,
                description: module === null || module === void 0 ? void 0 : module.summary
            } }));
    };
    return (React.createElement("div", { className: Styles.myModulesWrap },
        React.createElement("div", { className: Styles.content },
            React.createElement(HeaderModules, { percentage: cumulativeScore || 0, onContinue: handleOnContinue }),
            loading ? (React.createElement("div", { style: {
                    width: '100%',
                    height: '100%',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    marginTop: '20%'
                } },
                React.createElement(CircleLoader, null))) : (React.createElement(React.Fragment, null,
                React.createElement("div", { className: Styles.progressBarContent },
                    React.createElement(ProgressBar, { backgroundColor: "green", percentage: currentProgress })),
                React.createElement("div", { className: Styles.modulesGrid },
                    modules.map((module, index) => setItemByStatus(module, index)),
                    currentProgress === 100 ? (React.createElement(ModuleCertificateApproved, { onClick: () => __awaiter(void 0, void 0, void 0, function* () { return handleDownload(); }), grade: studentGradeText, onOpenCertificate: () => setOpenModalCertificate(!openModalCertificate), isDownloading: downloadCertficate })) : (React.createElement(ModuleCertificateDesApproved, { onClick: () => __awaiter(void 0, void 0, void 0, function* () { return handleDownload(); }), grade: studentGradeText, onOpenCertificate: () => setOpenModalCertificate(!openModalCertificate) })),
                    openModalCertificate && (React.createElement(ModalCertificate, { open: openModalCertificate, onClose: () => setOpenModalCertificate(!openModalCertificate), grade: studentGrade }, certificateRender(studentGrade, '60vh', '83vh')))),
                React.createElement("div", { ref: containerRef, style: { display: downloadCertficate ? 'block' : 'none' } }, certificateRenderDownload(studentGrade, '558.594px', '797.624px')))))));
};
export default MyModules;
